export default __webpack_public_path__ + "static/media/trancosoIcon.2d000f90.svg";